import React from 'react';
import Anchor from '../../../../components/link/Anchor';

const OpenNoticeProductItem = (props) => {
  const { productNoticeId, productCount, openNoticeProductItemListModal } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (!productCount) {
    return '-';
  }

  return (
    <Anchor
      color="primary"
      isUnderLine
      text={productCount}
      onClick={() =>
        openNoticeProductItemListModal({
          productNoticeId,
        })
      }
    />
  );
};

export default OpenNoticeProductItem;
